import React, { Component, useState } from "react";
import uuid from "react-uuid";
import { connect } from "react-redux";
import { Alert } from "reactstrap";
import * as actionTypes from "../../../../store/Actions/actions";
import * as UTILS from "../../../../utils/Utils";
import cloneDeep from "lodash.clonedeep";
import Popup from "../../../Modal/Popup";
import shortid from "shortid";
import "./Blocks.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import Loader from "../../../../assets/images/spinner.gif";
import { Col } from "reactstrap";
import { track } from "@amplitude/analytics-browser";
import Axios from "../../../../axios";
let _isMounted = false;
class Blocks extends React.Component {
  constructor(props) {
    super(props);
    this.scrollerRef = React.createRef();
    this.state = {
      blockID: null,
      layout: null,
      id: this.props.ID,
      addedBlock: false,
      blocks: [],
      selectedBlock: "",
      loader: false,
      blockToPush: null,
      activeTab: "0",
      selectedCategory: "hero/header",
      page: 1,
      disableButton: true,
    };
    this.pushBlockToCanvas = this.pushBlockToCanvas.bind(this);
  }
  componentDidMount = () => {
    track("Blocks Option Accessed", {
      trigger: "Block options in the addElement Modals",
    });
    _isMounted = true;
    this.getBlocks();
    this.setState({
      selectedBlock: "",
      // loader: true,
    });
  };
  componentWillUnmount = () => {
    _isMounted = false;
    this.setState({
      selectedBlock: "",
      loader: true,
    });
  };
  getBlocks = () => {
    this.setState({
      loader: true,
    });

    Axios.BlockService.GET_BLOCK_THUMBNAILS(
      this.props.userID,
      this.props.sessionID,
      `B&c=${this.state.selectedCategory}&page=${this.state.page}`
    )
      .then((response) => {
        if (response.status === 200 && _isMounted) {
          let data = response.data.data[this.state.selectedCategory]
            ? response.data.data[this.state.selectedCategory]
            : [];
          this.setState({
            blocks: [...this.state.blocks, ...data],
            loader: false,
            page: this.state.page + 1,
            more: data.length > 0 ? true : false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          blocks: [],
          loader: false,
        });
      });
  };

  selectedBlock = async (blockData) => {
    let requestData = await Axios.BlockService.GET_BLOCK_DATA(
      blockData.template_id,
      this.props.userID,
      this.props.sessionID
    );
    let { data } = requestData.data;

    this.setState(
      {
        // selectedBlock: blockData,
        selectedBlock: data,
      },
      () => {
        // let layout =
        //   this.state.selectedBlock &&
        //   this.state.selectedBlock.data &&
        //   JSON.parse(this.state.selectedBlock.data).block;

        let layout = null;
        try {
          layout = JSON.parse(this.state.selectedBlock.data);
          const newLayout = UTILS.ConvertTextContent(
            layout,

            (item) => {
              item.text = UTILS.ConvTextChar(item.text);
            },
            (colItem) => {
              colItem.text = UTILS.ConvTextChar(colItem.text);
            },
            (colItemNested) => {
              colItemNested.text = UTILS.ConvTextChar(colItemNested.text);
            }
          );

          this.setState({
            blockToPush: newLayout,
            disableButton: false,
          });
        } catch (e) {
          this.setState({
            disableButton: true,
          });
        }
      }
    );
  };

  pushBlockToCanvas = () => {
    let newLayout = cloneDeep(this.props.layout);
    const data = this.state.blockToPush;
    const newData = UTILS.IDFilter(
      data,
      (item) => {
        item.id = "F" + shortid();
      },
      (colItem) => {
        colItem.id = "F" + shortid();
      },
      (colItemNested) => {
        colItemNested.id = "F" + shortid();
      }
    );
    const newDataReversed = JSON.parse(JSON.stringify(this.state.blockToPush));

    if (newLayout.length === 0) {
      newData.forEach((elementItems) => {
        newLayout.push(elementItems);
      });
    } else {
      newLayout.forEach((item, key) => {
        let num = 0;
        if (item.id === this.props.ID) {
          newDataReversed.forEach((elementItems) => {
            
            newLayout.splice(key + (1 + num), 0, elementItems);
            num++;
          });
        } else {
          item.columns &&
            Object.keys(item.columns).forEach((col) => {
              item.columns[col].forEach((colItem, key) => {
                let num = 0;
                if (colItem.id === this.props.ID) {
                  newDataReversed.forEach((elementItems) => {

                    item.columns[col].splice(key + (1 + num), 0, elementItems);
                    num++;
                  });
                } else if (colItem.columns) {
                  Object.keys(colItem.columns).forEach((nestedColKey) => {
                    colItem.columns[nestedColKey].forEach((nestedCol) => {
                      if (nestedCol.id === this.props.ID) {
                        notificationApi["error"]({
                          message: "Drag Block Error",
                          description:
                            "Cannot nest elements any further, maximum nesting level reached",
                          placement: "bottomRight",
                        });
                      }
                    });
                  });
                }
              });
            });
        }
      });
    }

    this.setState(
      {
        addedBlock: true,
      },
      () => {
        setTimeout(
          function () {
            this.setState({ addedBlock: false });
          }.bind(this),
          2000
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
    this.props.closeBlocks();
  };
  getLayoutList = () => {
    const selectedLayout = this.props.layoutList.map((item, ind) => {});
  };
  handleScroll = async () => {
    const scroller = this.scrollerRef.current;
    if (
      scroller.scrollTop + scroller.clientHeight >=
        scroller.scrollHeight - 30 &&
      !this.state.loader &&
      this.state.more
    ) {
      this.getBlocks();
    }
  };

  render() {
    return (
      <Popup
        width="800"
        header=" Choose Blocks"
        save={this.pushBlockToCanvas}
        btnLabel="Select"
        parentID="chooseBlockWrapp"
        closePopup={this.props.closeBlocks}
        close={this.props.closeBlocks}
        disableButton={this.state.disableButton}
      >
        {" "}
        {this.state.loader && this.state.page === 1 ? (
          <div className="loadingBlock">
            <p>
              <img src={Loader} />
            </p>
            Blocks are loading...
          </div>
        ) : (
          ""
        )}
        <div className="templateSarchSec">
          <select
            onChange={(e) => {
              this.setState(
                {
                  blocks: [],
                  selectedCategory: e.target.value,
                  page: 1,
                },
                () => {
                  this.getBlocks();
                  track("Block Category Selected", {
                    trigger: "Block options in the addElement Modals",
                    categoryName: e.target.value,
                  });
                }
              );
            }}
          >
            <option value="hero/header">Hero / Header (24)</option>
            <option value="featured content">Featured Content (24)</option>
            <option value="video">Video (31)</option>
            <option value="cta/informative">CTA / Informative (135)</option>
            <option value="lists">Lists (12)</option>
            <option value="footer">Footer (7)</option>
            <option value="custom">Custom</option>
          </select>
          <input
            // onChange={this.searchHandler.bind(this)}
            placeholder="Search block"
            type="text"
            style={{ display: "none" }}
          />
        </div>
        <div className="layoutContent blocksMain">
          <Col sm="12">
            <div
              className="scrollContainer blocks blockThumbs"
              ref={this.scrollerRef}
              onScroll={this.handleScroll}
            >
              <ul data-role="drag-drop-container">
                {this.state.blocks.map((item, itemIndex) => {
                  return (
                    <li
                      className={
                        item.template_id ===
                        this.state.selectedBlock.template_id
                          ? "active"
                          : " "
                      }
                      key={itemIndex}
                    >
                      <div className="wrapperImg">
                        <img
                          className="block-thumb"
                          onClick={() => {
                            this.selectedBlock(item);
                          }}
                          src={item.thumb}
                        />
                        <p data-id={item.template_id}></p>
                      </div>

                      <p className="title-block">
                        {item.template_name == null && (
                          <small
                            onClick={(e) => {
                              e.stopPropagation();
                              // this.setState({
                              //   templateTitleEnable: item.template_id
                              // })
                            }}
                            className="title-template noTitle"
                          >
                            No name available
                          </small>
                        )}
                        {item.template_name !== null && (
                          <small
                            className="title-template titleMain"
                            style={{ fontWeight: "500", color: "#0c3254" }}
                          >
                            {item.template_name}
                            {/* <button className="icoWrap"><img onClick={() => {
                                this.setState({
                                  templateTitleEnable: item.template_id,
                                  templateTitle: item.template_name
                                })
                              }} src={Rename} /></button> */}
                          </small>
                        )}
                      </p>
                    </li>
                  );
                })}
              </ul>
            </div>
          </Col>
        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    glblClrs: state.present.colorsGlobal,
    preset: state.present.preset,
    containerBg: state.present.containerBgColor,
    containerWidth: state.present.containerWidth,
    pixel: state.present.pixel,
    percentage: state.present.percentage,
    layout: state.present.layout,
    imagesGlobal: state.present.imagesGlobal,
    bgImage: state.present.bgImage,
    bgImageId: state.present.bgImageId,
    bgImageIndex: state.present.bgImageIndex,
    layoutTitle: state.present.layoutTitle,
    selectedFont: state.present.selectedFont,
    layoutList: state.present.layoutList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    pushGlobalColorArray: (colorGlobal) =>
      dispatch(actionTypes.global_colors(colorGlobal)),
    pushGlobalColorPreset: (presetColor) =>
      dispatch(actionTypes.preset(presetColor)),
    pushBgColor: (color) => dispatch(actionTypes.add_bg(color)),
    pushSelectedFont: (font) => dispatch(actionTypes.add_font(font)),
    pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
    pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
    pushPercentage: (percentageVal) =>
      dispatch(actionTypes.percentage(percentageVal)),
    pushBGimage: (image, id) => dispatch(actionTypes.bg_image(image, id)),
    pushBGImages: (images) => dispatch(actionTypes.bg_images(images)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
    pushBGIndex: (index) => dispatch(actionTypes.bg_image_index(index)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Blocks);
